export default __webpack_public_path__ + "static/media/colinKozmaMobile.951cefa2.jpg";